// components
import { ResultList } from "./result-list";
import { CollapsedSidebar } from "../../ui/collapsed-sidebar";
import { useResultsContext } from "../../../services/context/results-context";
import { SidebarResultsEmpty } from "./sidebar-results-empty";
import { RunnerList } from "./runner-list";
import { useUserContext } from "../../../services/context/user-context";

export const SidebarResults = ({
  selectedRunner,
  setSelectedRunner,
  resultList,
  selectedResult,
  setSelectedResult,
}) => {
  const {runners} = useResultsContext();
  const { viewOnly } = useUserContext();
  // For clarity
  const hasRunners = !!runners && runners.length > 0;
  const isRunnerSelected = !!selectedRunner;
  const selectedRunnerState = isRunnerSelected && runners.find((r) => r.id === selectedRunner.id).state;
  return (
    <CollapsedSidebar
      status={isRunnerSelected ? selectedRunnerState : null}
      title={isRunnerSelected ? selectedRunner.name : "Generations"}
      displayBackBtn={isRunnerSelected}
      setSelectedRunner={setSelectedRunner}
      viewOnly={viewOnly}
    >
      {hasRunners ? (
        <>
          {isRunnerSelected ? (
            <ResultList
              resultList={resultList}
              selectedResult={selectedResult}
              setSelectedResult={setSelectedResult}
              selectedRunnerId={selectedRunner.id}
            />
          ) : (
            <RunnerList
              /* runnerList={runners} */
              selectedRunner={selectedRunner}
              setSelectedRunner={setSelectedRunner}
            />
          )}
        </>
      ) : (
       <SidebarResultsEmpty/>
      )}
    </CollapsedSidebar>
  );
};
